import { Line } from "react-chartjs-2";

import { Chart as ChartJS, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend } from "chart.js";
ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend);

const BarChart = ({ chartLabels, chartData, customData }) => {
  const formattedLabels = chartLabels.map((dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
    });
  });

  const barChartData = {
    labels: formattedLabels,
    datasets: customData ? customData : [
      {
        label: "",
        data: chartData,
        borderColor: "rgb(47, 117, 255)",
        backgroundColor: "rgba(47, 117, 255)",
        fill: false,
        pointRadius: 0,
        pointHoverRadius: 5,
      },
    ],
  };

  const options = {
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        min: 0,
        ticks: {
          callback: function (value) {
            return Number.isInteger(value) ? value : 0;
          },
        },
      },
      x: {
        ticks: {
          font: {
            size: 10,
          },
        },
      },
    },
  };

  const data = barChartData;
  return (
    <div className="flex flex-col justify-center items-center">
      <Line options={options} data={data} />
    </div>
  );
};

export default BarChart;
